import { clearGroupNotice, useGroupChatStore } from '../../../lib/group-chat-api';
import { useGroupChatRealtime, useGroupLiveFrames, useGroupPresenceHeartbeat, usePendingGroupResume } from '../../../lib/use-group-chat-session';
import { useTranslation } from '../../../lib/i18n';
import { Toast } from '../ui';

/**
 * Mounted once in AppFrame. The member-scoped realtime channel and the notice a lost group leaves ("You're no longer
 * in this group" / "This group was ended") are behind `symphonyGroupChat` (the realtime hook subscribes nothing with
 * it off, and nothing posts a notice). The invite resume is not: an invitee's account may not have the flag.
 */
export function GroupChatHost() {
  const { t } = useTranslation();
  useGroupChatRealtime();
  // Design §21: receipts, typing and presence frames, and this browser's own online heartbeat (behind the flag).
  useGroupLiveFrames();
  useGroupPresenceHeartbeat();
  usePendingGroupResume();
  const { notice } = useGroupChatStore();
  return (
    <Toast open={!!notice} message={notice ? [t(notice.key, notice.vars), notice.extraKey ? t(notice.extraKey) : ''].filter(Boolean).join(' ') : ''} placement="top" onClose={clearGroupNotice}
      // Phase 10b: "Message deleted for you" carries its Undo.
      action={notice?.action ? { label: t(notice.action.labelKey), onClick: () => { const run = notice.action?.run; clearGroupNotice(); run?.(); } } : undefined} />
  );
}
